import * as React from 'react';
import { nestedAccess, arrayBetween } from './../../helpers';
import { Row, Col } from './../../index';
import { Card, CardBody } from '../Card';
import { color } from 'csx';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
import { Text } from '../Text';
import { Menu, MenuItem } from '../Menu';
import { style } from './style';
import { daysInMonth, compareDesc } from '../../helpers/date';
export const Calendar = (props) => {
    const initialDate = (date = props.date) => {
        return date !== null && date !== void 0 ? date : new Date();
    };
    const toWeeksDateArray = (date = initialDate()) => {
        const dateObj = [];
        let monthStart = 1;
        for (let i = 0; i < 6; i++) {
            const obj = {};
            for (let j = new Date(date.getFullYear(), date.getMonth(), monthStart).getDay(); j < 7; j++) {
                if (monthStart > daysInMonth(date.getFullYear(), date.getMonth())) {
                    break;
                }
                obj[weeks[j]] = monthStart;
                monthStart++;
            }
            dateObj.push(obj);
        }
        return dateObj;
    };
    const [date, updateDate] = React.useState(initialDate());
    const [weeksDateArray, updatetoWeeksDateArray] = React.useState(toWeeksDateArray());
    const isToday = (day) => {
        const [year, month] = [date.getFullYear(), date.getMonth()];
        const today = new Date();
        return today.getFullYear() === year && today.getMonth() === month && today.getDate() === day;
    };
    const monthChange = (month) => {
        const newDate = date;
        newDate.setMonth(months.indexOf(month));
        updateDate(newDate);
        updatetoWeeksDateArray(toWeeksDateArray(newDate));
    };
    const yearChange = (year) => {
        const newDate = date;
        newDate.setFullYear(year);
        updateDate(newDate);
        updatetoWeeksDateArray(toWeeksDateArray(newDate));
    };
    const calendarEvent = (day, style) => {
        if (!day) {
            return;
        }
        const { calendarEvents } = props;
        const [year, month] = [date.getFullYear(), date.getMonth()];
        if (!calendarEvents) {
            return;
        }
        return calendarEvents.map((v) => {
            const [startDate, endDate] = [initialDate(v.startDate), initialDate(v.endDate)];
            if (day === startDate[2] && month === startDate[1] && year === startDate[0]) {
                return (React.createElement(Tooltip, { placement: "top", trigger: ['hover'], overlay: v.eventName },
                    React.createElement("div", { className: style.badge, style: {
                            borderRadius: '4px 0 0 4px',
                            background: v.color || '#fcc',
                            boxShadow: '0 10px 14px ' +
                                color(v.color || '#fcc')
                                    .fade(0.4)
                                    .toString(),
                        } })));
            }
            if (compareDesc(startDate, new Date(year, month, day)) === 1 &&
                compareDesc(new Date(year, month, day), endDate) === 1) {
                return (React.createElement(Tooltip, { placement: "top", trigger: ['hover'], overlay: v.eventName },
                    React.createElement("div", { className: style.badge, style: {
                            background: v.color || '#fcc',
                            boxShadow: '0 10px 14px ' +
                                color(v.color || '#fcc')
                                    .fade(0.4)
                                    .toString(),
                        } })));
            }
            if (day === endDate[2] && month === endDate[1] && year === endDate[0]) {
                return (React.createElement(Tooltip, { placement: "top", trigger: ['hover'], overlay: v.eventName },
                    React.createElement("div", { className: style.badge, style: {
                            borderRadius: '0 4px 4px 0',
                            background: v.color || '#fcc',
                            boxShadow: '0 10px 14px ' +
                                color(v.color || '#fcc')
                                    .fade(0.4)
                                    .toString(),
                        } })));
            }
        });
    };
    const css = style;
    return (React.createElement(Card, { elevation: props.elevation },
        React.createElement(CardBody, null,
            React.createElement(Row, { gutter: [0, '5px'], justifyContent: "flex-end" },
                React.createElement(Col, { flex: "0 1 auto" },
                    React.createElement(Menu, { height: "300px", trigger: "onClick", anchor: React.createElement(Button, { primary: true, displayBlock: true, flat: true }, months[date.getMonth()]) }, months.map((v) => (React.createElement(MenuItem, { active: v === months[date.getMonth()], onClick: () => monthChange(v), key: v }, v))))),
                React.createElement(Col, { flex: "0 1 auto" },
                    React.createElement(Menu, { height: "300px", trigger: "onClick", anchor: React.createElement(Button, { primary: true, displayBlock: true, flat: true }, date.getFullYear()) }, arrayBetween(1980, 2030).map((v) => (React.createElement(MenuItem, { active: v === date.getFullYear(), onClick: () => yearChange(v), key: v }, v)))))),
            React.createElement(Row, { gutter: [0, 0] }, weeks.map((v) => (React.createElement(Col, { span: 24 / 7, key: v },
                React.createElement(Text, { fontWeight: 600, textAlign: "center", variant: "p", color: "light" }, v.slice(0, 3)))))),
            React.createElement(Row, { gutter: [0, 0] }, weeksDateArray.map((v) => {
                return weeks.map((f, i) => {
                    var _a, _b;
                    const selectedDate = props.date;
                    const isSelectedDate = selectedDate &&
                        compareDesc(new Date(date.getFullYear(), date.getMonth(), nestedAccess(v, f), selectedDate.getHours(), selectedDate.getMinutes(), selectedDate.getSeconds(), selectedDate.getMilliseconds()), selectedDate) === 0;
                    const today = isToday(v === null || v === void 0 ? void 0 : v[f]);
                    const newDate = new Date(date.getFullYear(), date.getMonth(), nestedAccess(v, f), (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getHours()) || 0, (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getMinutes()) || 0, (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getSeconds()) || 0, (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getMilliseconds()) || 0);
                    return (React.createElement(Col, { className: css.cell, key: i, span: 24 / 7 },
                        nestedAccess(v, f) ? (((_a = props.cellRender) === null || _a === void 0 ? void 0 : _a.call(props, newDate, f)) || (React.createElement(Button, { disabled: (_b = props.disabledDate) === null || _b === void 0 ? void 0 : _b.call(props, newDate), flat: !today && !isSelectedDate, shape: "circle", outline: today, primary: today || isSelectedDate || false, onClick: () => {
                                var _a;
                                return !((_a = props.disabledDate) === null || _a === void 0 ? void 0 : _a.call(props, newDate)) && props.onClick && props.onClick(newDate);
                            } }, v === null || v === void 0 ? void 0 : v[f]))) : (React.createElement("div", null)),
                        props.calendarEvents && React.createElement("div", { className: css.dateContent }, calendarEvent(v === null || v === void 0 ? void 0 : v[f], css))));
                });
            })))));
};
export var weeksEnum;
(function (weeksEnum) {
    weeksEnum["MONDAY"] = "MONDAY";
    weeksEnum["TUESDAY"] = "TUESDAY";
    weeksEnum["WEDNESDAY"] = "WEDNESDAY";
    weeksEnum["THURSDAY"] = "THURSDAY";
    weeksEnum["FRIDAY"] = "FRIDAY";
    weeksEnum["SATURDAY"] = "SATURDAY";
    weeksEnum["SUNDAY"] = "SUNDAY";
})(weeksEnum || (weeksEnum = {}));
export const weeks = [
    weeksEnum.SUNDAY,
    weeksEnum.MONDAY,
    weeksEnum.TUESDAY,
    weeksEnum.WEDNESDAY,
    weeksEnum.THURSDAY,
    weeksEnum.FRIDAY,
    weeksEnum.SATURDAY,
];
export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
//# sourceMappingURL=Calendar.js.map